import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "smile_just",
  "use": "smile_just-usage",
  "viewBox": "0 0 338.000000 338.000000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 338.000000 338.000000\" preserveAspectRatio=\"xMidYMid meet\" id=\"smile_just\">\n<metadata>\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n</metadata>\n<g transform=\"translate(0.000000,338.000000) scale(0.100000,-0.100000)\" fill=\"#000000\" stroke=\"none\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/smile_just.svg
// module id = kBwq
// module chunks = 0